<template src="./restrictionsList.template.html"></template>
<script>  
    export default {
        name: "restrictionsList",
        props: [],
        data() {
            return {
                restrictionsList: [],
                propertyList: [],
                headerColumnList: [],
                toggleFilterPanel:false,
                headerColumnList: {

                    PROPERTYNAME: { Label: "PROPERTY NAME", IsChecked: true, ColumnName: "PropertyName", isSortLoading: false, isAscOrDesc: null },
                    UNITNAME: { Label: "UNIT NAME", IsChecked: true, ColumnName: "UnitName", class: "filterLoad", isSortLoading: false, isAscOrDesc: null },
                    RESTRICTIONNAME: { Label: "RESTRICTION NAME", IsChecked: true, ColumnName: "RestrictionName", class: "filterLoad", isSortLoading: false, isAscOrDesc: null },
                    RESTRICTIONTYPE: { Label: "RESTRICTION TYPE", IsChecked: true, ColumnName: "RestrictionTypeName", class: "filterLoad", isSortLoading: false, isAscOrDesc: null },

                },

                filterObj: {
                    SortBy: null,
                    SortOrder: null,

                },


            };
        },
        methods: {

            closeFilter: function () {
        this.toggleFilterPanel = false
      },

            ascSort(sortBy, sortOrder) {
                let vm = this;
                vm.filterObj.SortBy = sortBy;
                vm.filterObj.SortOrder = sortOrder;
                for (var i in vm.headerColumnList) {
                    if (vm.headerColumnList[i].ColumnName !== "LOGO") {
                        var obj = vm.headerColumnList[i];
                        console.log("obj", obj);
                        // for (var j in obj.sortLabels) {
                        if (sortBy.toString() === obj.ColumnName) {
                            console.log("obj.ColumnName", obj.ColumnName);
                            vm.headerColumnList[i].isSortLoading = true;
                            vm.headerColumnList[i].isAscOrDesc = sortOrder.toString();
                            //   }
                            // }
                        }
                    }
                }

                vm.getRestrictionsList();
                // for (var i in vm.headerColumnList) {

                //     var obj = vm.headerColumnList[i];
                //     console.log("obj", obj)
                //     if (sortBy.toString() === obj.ColumnName) {
                //         console.log("obj.ColumnName", obj.ColumnName);
                //         vm.headerColumnList[i].isSortLoading = true;
                //         vm.headerColumnList[i].isAscOrDesc = sortOrder.toString();
                //     }
                // }

                //vm.getReservationsList(vm.propertyId, vm.UnitClassId, vm.ViewListId, SortBy, SortOrder, vm.sourceID);
            },
            getRestrictionsList: function () {
                let scope = this;
                this.$store.dispatch("dataRequestHandler", {
                    key: "GetRestrictionList",
                    params: {
                        filterObj: scope.filterObj
                    },
                    callback: function (err, response) {
                        if (response) {
                            scope.restrictionsList.splice(0, scope.restrictionsList.length, ...response.restrictionsList);
                            scope.propertyList.splice(0, scope.propertyList.length, ...response.propertyList);
                            // if (scope.restrictionsList.length > 0) {
                            //     scope.$store.dispatch("toastr", {
                            //         type: "success",
                            //         header: "Success!",
                            //         message: "restrictionsList  Rendered"
                            //     });
                            // }
                            scope.loading = false;
                            for (var i in scope.headerColumnList) {

                                if (scope.headerColumnList[i].ColumnName !== "LOGO") {
                                    var obj = scope.headerColumnList[i];
                                    console.log("obj", obj)

                                    if (scope.filterObj.SortBy === obj.ColumnName.toString()) {
                                        console.log("obj.ColumnName", obj.ColumnName);
                                        scope.headerColumnList[i].isSortLoading = false;
                                        // vm.headerColumnList[i].isAscOrDesc = sortOrder.toString();
                                    }

                                }
                            }
                        } else {
                            console.log(err);
                        }
                    }
                });
            },
            navigateToNewRestrictionDetails(restrictionId) {
                console.log(restrictionId);
                this.$router.push("/restrictionDetail/" + (restrictionId ? restrictionId : -1));
            }
        },
        computed: {},
        watch: {},
        mounted() {
            this.getRestrictionsList();
            $(this.$el).find("ul.dropdown-menu").click(function (e) {
                e.stopPropagation();
            });
        }
    }
</script>